// extracted by mini-css-extract-plugin
module.exports = {"meal":"Meal_meal__2yGk3","mealContainer":"Meal_mealContainer__BNAKJ","addButton":"Meal_addButton__2aSTL","mealForm":"Meal_mealForm__36a2d"};